// ---------------------------------------------------------------------------
// Shared agent name resolution — single source of truth for converting
// AppScenario + ProductEntryPoint into user-friendly display names.
// Used by the calendar view, debug view, and shared signals page.
// ---------------------------------------------------------------------------

/** Maps AppScenario values to friendly display names */
const AGENT_FRIENDLY_NAMES: Record<string, string> = {
  MeetingOrchestratorReactiveOnCanvas: 'Facilitator',
  TeamsChatAgentCopilot: 'Chat Agent',
  TeamsFlwCopilotOnCanvas: 'Frontline Copilot',
  TeamsFlwOnCanvas: 'Frontline Agent',
  TeamsOrchestratorOnCanvas: 'Channel Agent',
};

/** For TeamsChatCopilot (Sydney), resolve via ProductEntryPoint */
const SYDNEY_ENTRY_POINT_NAMES: Record<string, string> = {
  TeamsFlwCopilot: 'Frontline Copilot',
  TeamsChatAgent: 'Chat Agent',
};

export function isTeamsAgentSignal(
  appScenario: string | undefined,
  clientAppName: string | undefined,
): boolean {
  return (
    appScenario === 'TEXASOnCanvas' && clientAppName === 'TEX Agent Service'
  );
}

/**
 * Resolves a user-friendly agent name from execution context fields.
 * Returns the friendly name if a mapping exists, the raw AppScenario if no mapping
 * is found, or undefined if appScenario is empty/undefined.
 */
export function getFriendlyAgentName(
  appScenario: string | undefined,
  productEntryPoint?: string,
  clientAppName?: string,
): string | undefined {
  if (!appScenario) return undefined;
  if (isTeamsAgentSignal(appScenario, clientAppName)) {
    return 'Teams Agent';
  }
  // For TeamsChatCopilot, prefer ProductEntryPoint mapping
  if (appScenario === 'TeamsChatCopilot' && productEntryPoint) {
    return SYDNEY_ENTRY_POINT_NAMES[productEntryPoint] ?? productEntryPoint;
  }
  return AGENT_FRIENDLY_NAMES[appScenario] ?? appScenario;
}
